var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 0.863037V5.08546H35.1691L27.3787 12.8758C24.5074 10.638 20.9395 9.30789 17.0337 9.30789C7.7233 9.30789 0.144043 16.8871 0.144043 26.1976C0.144043 35.508 7.7233 43.0873 17.0337 43.0873C26.3442 43.0873 33.9235 35.508 33.9235 26.1976C33.9235 22.2919 32.5934 18.7239 30.3555 15.8527L38.1459 8.06227V15.6415H42.3683V0.863037H27.5898ZM17.0337 38.8649C10.0456 38.8649 4.36647 33.1857 4.36647 26.1976C4.36647 19.2095 10.0456 13.5303 17.0337 13.5303C24.0219 13.5303 29.701 19.2095 29.701 26.1976C29.701 33.1857 24.0219 38.8649 17.0337 38.8649Z",
    fill: "url(#paint0_linear_1092_3649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_3649",
    x1: 77.9462,
    y1: -26.1136,
    x2: -11.3162,
    y2: 49.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E96039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#EB6E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2942F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.cd02fc0f6996b220fa9b7c3ac7cf50c1.svg";
export { ForwardRef as ReactComponent };